export const uniqueId = (prefix?: string) =>
  `${prefix ? prefix + '-' : ''}${Date.now()}-${Math.random() * 1000}`
